
export default {
  name: "Location",
};
